import React from 'react';
import { ChartData, ScatterDataPoint } from 'chart.js';
import { Line } from 'react-chartjs-2';
import Box from '@mui/material/Box';

import ChartWrapper from './ChartWrapper';
import { useMetrics } from '../../Contexts/metrics-context';
import { getObjectsPerDate } from '../../Utils/metricsSerializer';
import chartColors from '../../Constants/colors';
import defaultGraphOptions from '../../Constants/defaultGraphOptions';

export default function ChartObjectsPerDays() {
  const { stateMetrics } = useMetrics();

  const objectsPerDate = React.useMemo(
    () =>
      getObjectsPerDate(stateMetrics.metricsOutput, stateMetrics.chartsFormat),
    [stateMetrics.metricsOutput, stateMetrics.chartsFormat],
  );

  const labelsUniq = React.useMemo(() => {
    const labels: string[] = [];
    Object.keys(objectsPerDate).map((value) =>
      Object.keys(objectsPerDate[value]).map((value2) => {
        labels.push(value2);
      }),
    );

    const uniqLabels = [...new Set(labels)];
    uniqLabels.sort(function (a, b) {
      return ('' + a).localeCompare(b);
    });
    return uniqLabels;
  }, [stateMetrics.metricsOutput, stateMetrics.chartsFormat]);

  /*eslint-disable */
  const data_: ChartData<
    'line',
    (number | ScatterDataPoint | null)[],
    unknown
  > = {
    labels: labelsUniq,
    datasets: [],
  };

  Object.keys(objectsPerDate).map((value, index) => {
    data_.datasets.push({
      type: 'line' as const,
      label: value,
      data: objectsPerDate[value] as any,
      borderColor: chartColors.lineCharts.borders[index],
      backgroundColor: chartColors.lineCharts.backgrounds[index],
    });
  });
  /*eslint-enable */

  return (
    <React.Fragment>
      <ChartWrapper title="Objects per date">
        <div>
          <Box style={{ height: '400px', margin: 'auto' }}>
            <Line options={defaultGraphOptions.line} data={data_} />
          </Box>
        </div>
      </ChartWrapper>
    </React.Fragment>
  );
}
